import { render, staticRenderFns } from "./DetailedPayment.vue?vue&type=template&id=5cb16736&scoped=true&"
import script from "./DetailedPayment.vue?vue&type=script&lang=js&"
export * from "./DetailedPayment.vue?vue&type=script&lang=js&"
import style0 from "./DetailedPayment.vue?vue&type=style&index=0&id=5cb16736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb16736",
  null
  
)

export default component.exports